import { render, staticRenderFns } from "./PageSetUpGood.vue?vue&type=template&id=08494dd2&scoped=true&"
import script from "./PageSetUpGood.vue?vue&type=script&lang=js&"
export * from "./PageSetUpGood.vue?vue&type=script&lang=js&"
import style0 from "./PageSetUpGood.vue?vue&type=style&index=0&id=08494dd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08494dd2",
  null
  
)

export default component.exports